import api from "./api";
import { getStoredClientId, getStoredUser } from "../utils/tokenUtils";

const sharedStepService = {
  /**
   * Get all shared steps for a project
   */
  getSharedSteps: async (projectId, filters = {}) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      project_id: projectId,
      client_id: storedClientId || user?.client_id,
      search: filters.search || undefined,
      sort: filters.sort || undefined,
    };
    const response = await api.post("api/shared-steps/list", payload);
    return response.data;
  },

  /**
   * Get shared step by ID
   */
  getSharedStepById: async (sharedStepId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      shared_step_id: sharedStepId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("api/shared-steps/get", payload);
    return response.data;
  },

  /**
   * Create a new shared step
   */
  createSharedStep: async (sharedStepData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...sharedStepData,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("api/shared-steps/create", payload);
    return response.data;
  },

  /**
   * Update a shared step
   */
  updateSharedStep: async (sharedStepId, updates) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      shared_step_id: sharedStepId,
      ...updates,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("api/shared-steps/update", payload);
    return response.data;
  },

  /**
   * Delete a shared step
   */
  deleteSharedStep: async (sharedStepId) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      shared_step_id: sharedStepId,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("api/shared-steps/delete", payload);
    return response.data;
  },

  /**
   * Link shared step to test case
   */
  linkToTestCase: async (sharedStepId, testCaseId, stepNumber) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      shared_step_id: sharedStepId,
      test_case_id: testCaseId,
      step_number: stepNumber,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post(
      "api/shared-steps/link-to-test-case",
      payload,
    );
    return response.data;
  },
};

export default sharedStepService;
